import axios from '@/axios.js'

export default {
  fetchUserCompanies ({ commit }) {
    return axios.get('/company')
      .then((response) => {
        commit('SET_COMPANIES', response.data)
        return response
      })
  },
  fetchUser (context, userId) {
    return axios.get(`/api/user-management/users/${userId}`)
  },
  removeRecord ({ commit }, userId) {
    return axios.delete(`/api/user-management/users/${userId}`)
      .then((response) => {
        commit('REMOVE_RECORD', userId)
        return response
      })
  }
}
